import { render, staticRenderFns } from "./warehouse.vue?vue&type=template&id=6edef367"
import script from "./warehouse.vue?vue&type=script&lang=js"
export * from "./warehouse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports